<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav pl-md-5">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" routerLink="/document-templates/" routerLinkActive="active">
        Document Templates
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/document-policies/" routerLinkActive="active">
        Policies
      </a>
    </li>
  </ul>
</nav>
